import script from "./JoinClass.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinClass.vue?vue&type=script&setup=true&lang=js"

import "./JoinClass.vue?vue&type=style&index=0&id=6415ed68&lang=scss&scoped=true"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6415ed68"]])

export default __exports__